import ACTIONS from '../actionTypes/auth'

const initialState = {
  session: null,
  isProcessingSigninCallback: false
}

const AuthReducer = (state = initialState, action) => {  
  switch (action.type) {
    // clearAuthData
    case ACTIONS.CLEAR_AUTH_DATA:
      return {
        ...initialState
      }
    // signinRedirectCallback
    case ACTIONS.START_SIGN_REDIRECT_CALLBACK:
      return {
        ...state,
        isProcessingSigninCallback: true
      }
    case ACTIONS.SIGN_REDIRECT_CALLBACK_SUCCESS:
      return {
        ...state,
        session: action.payload,
        isProcessingSigninCallback: false
      }
    case ACTIONS.SIGN_REDIRECT_CALLBACK_FAILED:
      return {
        ...state,
        isProcessingSigninCallback: false
      }

    // Default
    default:
      return state
  }
}

export default AuthReducer